import React from 'react';
import Typography from '@mui/material/Typography';
import { formatDateTime } from '../changelogAdminConfig';

/**
 * Situação da novidade nos envios: "Enviado no envio #3 (10/10/26 09:00)" (o mais recente),
 * "Agendado no envio #4 (...)" ou "Ainda não enviado", com o rascunho em que está, se houver.
 * @param {{ item: Object, excludeEditionId?: number }} props
 */
function ItemSentInfo({ item, excludeEditionId }) {
  const editions = (Array.isArray(item.editions) ? item.editions : [])
    .filter((edition) => edition.id !== excludeEditionId && edition.status !== 'canceled');
  const latest = (status, dateKey) => editions
    .filter((edition) => edition.status === status)
    .sort((a, b) => String(b[dateKey] || '').localeCompare(String(a[dateKey] || '')))[0];

  const sent = latest('sent', 'sent_at') || latest('sending', 'sent_at');
  const scheduled = latest('scheduled', 'scheduled_at');
  const draft = editions.find((edition) => edition.status === 'draft');

  let main = 'Ainda não enviado';
  if (sent) main = `Enviado no envio #${sent.number}${sent.sent_at ? ` (${formatDateTime(sent.sent_at)})` : ''}`;
  else if (scheduled) main = `Agendado no envio #${scheduled.number} (${formatDateTime(scheduled.scheduled_at)})`;

  return (
    <>
      <Typography variant="body2" sx={{ fontSize: '0.8125rem', color: sent ? 'text.primary' : 'text.secondary' }}>{main}</Typography>
      {draft && (
        <Typography variant="caption" color="text.secondary" component="div">No rascunho do envio #{draft.number}</Typography>
      )}
    </>
  );
}

export default ItemSentInfo;
